<template>
  <div
    class="my-contacts-root tw-relative tw-z-[1] md:tw-col-span-2 lg:tw-col-span-3 tw-font-lato tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)]"
  >
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <my-add-contact-popup />
    <my-add-action-popup />
    <my-import-contacts-popup />
    <my-social-share-popup />
  </div>
</template>

<script>
import myAddContactPopup from "@/views/donor-dashboard/my-contacts/modals/my-add-contact-popup.vue";
import myAddActionPopup from "@/views/donor-dashboard/my-contacts/modals/my-add-action-popup.vue";
import myImportContactsPopup from "@/views/donor-dashboard/my-contacts/modals/my-import-contacts-popup.vue";
import mySocialSharePopup from "@/views/donor-dashboard/my-contacts/modals/my-social-share-popup.vue";

export default {
  components: {
    myAddContactPopup,
    myAddActionPopup,
    myImportContactsPopup,
    mySocialSharePopup,
  },

  name: "my-contacts-wrapper",
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
